import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import {
  Tabs as ShadcnTabs,
  TabsList as ShadcnTabsList,
  TabsTrigger as ShadcnTabsTrigger,
  TabsContent as ShadcnTabsContent,
} from '#/modules/commonComponents/shadcn/ui/tabs';

/** ERP 樣式掛點（換皮只改此常數，禁止改 vendor） */
const TABS_ERP_CLASS = '';
const TABS_LIST_ERP_CLASS = 'h-auto group-data-horizontal/tabs:h-auto items-center';
const TABS_TRIGGER_ERP_CLASS = 'h-auto px-4 py-1';
const TABS_CONTENT_ERP_CLASS = '';

const Tabs = ({ className, ...props }) => (
  <ShadcnTabs
    className={cn(TABS_ERP_CLASS, className)}
    {...props}
  />
);

const TabsList = ({ className, ...props }) => (
  <ShadcnTabsList
    className={cn(TABS_LIST_ERP_CLASS, className)}
    {...props}
  />
);

const TabsTrigger = ({ className, ...props }) => (
  <ShadcnTabsTrigger
    className={cn(TABS_TRIGGER_ERP_CLASS, className)}
    {...props}
  />
);

const TabsContent = ({ className, ...props }) => (
  <ShadcnTabsContent
    className={cn(TABS_CONTENT_ERP_CLASS, className)}
    {...props}
  />
);

Tabs.propTypes = {
  className: PropTypes.string,
};

TabsList.propTypes = {
  className: PropTypes.string,
};

TabsTrigger.propTypes = {
  className: PropTypes.string,
};

TabsContent.propTypes = {
  className: PropTypes.string,
};

export {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
};
